import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import React from 'react';
import { Billboard, ExternalLink, InfoIcons } from 'components/ContentCards';
import ContentProgressCircle from 'components/ContentProgressCircle';
import FriendlyDuration from 'components/FriendlyDuration';
import InlineList from 'components/InlineList';
import { GoalPill } from 'components/Pill';
import { useCardContentDetails } from 'components/ContentCards/controllers';
import { checkIsPlaylist } from 'types/content/utils';
import useUniqueId from 'hooks/useUniqueId';
import getPictureUrl, { DIMENSIONS } from 'utils/image/getPictureUrl';
import useOnWebAssetClick from './useOnWebAssetClick';
import getHubContentLink from './getHubContentLink';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var SmartBillboard = function SmartBillboard(_ref) {
  var item = _ref.item;
  var id = item.id,
    name = item.name,
    description = item.description,
    goal = item.goal,
    user_rated_like = item.user_rated_like,
    commentCount = item.commentCount,
    commentCountUser = item.commentCountUser,
    rating_count = item.rating_count,
    parentContentId = item.parentContentId,
    thumbnailId = item.thumbnailId;
  var isPlaylist = checkIsPlaylist(item);
  var badge = isPlaylist ? item.badge : undefined;
  var hasUserBadge = isPlaylist ? item.hasUserBadge : false;
  var isSaved = isPlaylist ? item.isSaved : false;
  var audience = isPlaylist ? item.audience || 'all' : 'all';
  var _useCardContentDetail = useCardContentDetails(item),
    contentCount = _useCardContentDetail.contentCount,
    duration = _useCardContentDetail.duration,
    progress = _useCardContentDetail.progress,
    type = _useCardContentDetail.type,
    icon = _useCardContentDetail.icon;
  var _useOnWebAssetClick = useOnWebAssetClick(),
    onWebAssetClick = _useOnWebAssetClick.onWebAssetClick;
  var contentCountReadout = contentCount.value ? contentCount.readable : undefined;
  var qaId = useUniqueId(id.toString());
  var link = getHubContentLink({
    id: id,
    type: type.value,
    parentId: parentContentId
  });
  return /*#__PURE__*/_jsx(Billboard, {
    link: link,
    icon: icon,
    imageSource: getPictureUrl({
      id: thumbnailId,
      dimensions: DIMENSIONS.BILLBOARD
    }),
    badge: badge,
    hasUserBadge: hasUserBadge,
    id: "collection_title_".concat(qaId),
    title: name,
    subtitle: /*#__PURE__*/_jsxs(InlineList, {
      as: "span",
      itemAs: "span",
      splitBy: "dot",
      display: "inline",
      children: [type.readable, contentCountReadout, duration > 0 && /*#__PURE__*/_jsx(FriendlyDuration, {
        value: duration
      }), type.value !== 'topic' && progress && /*#__PURE__*/_jsx(ContentProgressCircle, {
        contentName: name,
        progress: progress,
        infoReadout: "full",
        scale: 5 / 6
      }), item.type === 'web' && !!item.webUrl && item.openInIframe === false && /*#__PURE__*/_jsx(ExternalLink, {
        webUrl: item.webUrl,
        assetName: item.name,
        onWasClicked: function onWasClicked() {
          return onWebAssetClick({
            type: item.type,
            markAsDoneMode: isPlaylist ? undefined : item.markAsDoneMode,
            userContentStatus: item.userContentStatus,
            contentId: item.id
          });
        }
      })]
    }),
    description: description,
    priorityPill: goal ? /*#__PURE__*/_jsx(GoalPill, {
      goal: goal
    }) : undefined,
    infoIcons: /*#__PURE__*/_jsx(InfoIcons, {
      isSaved: isSaved,
      visibility: audience === 'admin' ? 'private' : undefined,
      likeCount: rating_count,
      commentCount: commentCount,
      commentCountUser: commentCountUser,
      hasUserLiked: user_rated_like
    })
  });
};
export default SmartBillboard;